import React from 'react';
import CompanyTypesTable from '../components/CompanyTypesTable';

export function CompanyTypes() {
  return <CompanyTypesTable />;
}
